import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import StatsStrip from "@/components/sections/StatsStrip";
import Situation from "@/components/sections/Situation";
import Sectors from "@/components/sections/Sectors";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Contingency from "@/components/sections/Contingency";
import AdvanceFunding from "@/components/sections/AdvanceFunding";
import Referral from "@/components/sections/Referral";
import Urgency from "@/components/sections/Urgency";
import LeadForm from "@/components/sections/LeadForm";
import Footer from "@/components/sections/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative min-h-screen">
      <Header />
      <Hero />
      <StatsStrip />
      <Situation />
      <Sectors />
      <Services />
      <Process />
      <Contingency />
      <AdvanceFunding />
      <Referral />
      <Urgency />
      <LeadForm />
      <Footer />
    </main>
  );
}
